import React from "react";
import { Button } from "components/bootstrap";
import { IfPermitted } from "components/common";
import { createGRN } from "logic/permissions/GRN";
import useCollectionEntityMutation from "collections/hooks/useCollectionEntityMutation";
const EntityActions = ({ id, type, collectionId }) => {
  const { addEntities } = useCollectionEntityMutation(collectionId);
  const onAdd = () => {
    addEntities({ addedEntities: [createGRN(type, id)] });
  };
  return /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `collection_entities:edit:${collectionId}` }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", bsStyle: "primary", onClick: onAdd }, "Add"));
};
export default EntityActions;
